var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoEsign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C12.4163 0.00477657 15.9952 3.5837 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0ZM7.66667 6.33333H7C6.63181 6.33333 6.33333 6.63181 6.33333 7C6.33333 7.36819 6.63181 7.66667 7 7.66667H7.5C7.59205 7.66667 7.66667 7.74129 7.66667 7.83333V10.8333C7.66667 10.9254 7.59205 11 7.5 11H7C6.63181 11 6.33333 11.2985 6.33333 11.6667C6.33333 12.0349 6.63181 12.3333 7 12.3333H9.66667C10.0349 12.3333 10.3333 12.0349 10.3333 11.6667C10.3333 11.2985 10.0349 11 9.66667 11H9.16667C9.07462 11 9 10.9254 9 10.8333V7.66667C9 6.93029 8.40305 6.33333 7.66667 6.33333ZM7.82054 3.53511C7.2691 3.53511 6.82207 3.98214 6.82207 4.53358C6.82207 5.08502 7.2691 5.53205 7.82054 5.53205C8.37198 5.53205 8.81901 5.08502 8.81901 4.53358C8.81901 3.98214 8.37198 3.53511 7.82054 3.53511Z",
    fill: "#356F95"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoEsign);
export default __webpack_public_path__ + "static/media/info-esign.28f1fefc5929dba411bb5f28efc01a0f.svg";
export { ForwardRef as ReactComponent };